import React from "react"
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { H1 } from "../../../designSystem/typography/Heading";
import { PageSectionHeader } from "../../../designSystem/PageSectionHeader";
import { Divider } from "../../../designSystem/Divider";
import type { ButtonProps } from "../../../designSystem/button/Button";


export const PageSectionHeaderOverview = (): JSX.Element => 
{
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [_, setExpanded] = React.useState<boolean>(true);

    const button:ButtonProps = {
        variant: 'filled',
        text: 'en knap',
        onClick: () => alert('knap trykket')
    };
        
    
    return (
    
        <div>
            <H1>PageSectionHeaders</H1>
            <Divider />
            <Flex flexDirection="column" gap={24} style={{padding:'20px'}}>

                    <PageSectionHeader>
                        Default values (H2)
                    </PageSectionHeader>

                    <PageSectionHeader headerVariant="H3" icon="calendar">
                        With icon, H3
                    </PageSectionHeader>

                    <PageSectionHeader headerVariant="H2" icon="calendar" avatar={{text:"AB"}}>
                        With icon, H2, avatar
                    </PageSectionHeader>

                    <PageSectionHeader headerVariant="H2" icon="calendar" avatar={{text:"AB"}} subTitle={{text:"Subtitle"}}>
                        With icon, H2, avatar, subTitle
                    </PageSectionHeader>

                    <PageSectionHeader headerVariant="H2" icon="calendar" avatar={{text:"AB"}} subTitle={{text:"Subtitle", icon:"clock"}}>
                        With icon, H2, avatar, subTitle+icon
                    </PageSectionHeader>

                    <PageSectionHeader headerVariant="H2" icon="calendar" avatar={{text:"AB"}} subTitle={{text:"Subtitle", icon:"clock", iconColor:"#f00"}} onCollapseChanged={(collapsed)=>setExpanded(!collapsed)} defaultCollapsed={true}>
                        With icon, H2, avatar, subTitle+icon+color, toggle expand, defaultCollapsed:true
                    </PageSectionHeader>

                    <PageSectionHeader headerVariant="H2" icon="calendar" avatar={{text:"AB"}} subTitle={{text:"Subtitle", icon:"clock", iconColor:"#f00"}} onCollapseChanged={(collapsed)=>setExpanded(!collapsed)} defaultCollapsed={true} button={button}>
                        With icon, H2, avatar, subTitle+icon+color, toggle expand, defaultCollapsed:true, button
                    </PageSectionHeader>

                    <PageSectionHeader headerVariant="H2" avatar={{text:"AB"}} subTitle={{text:"Subtitle"}} onCollapseChanged={(collapsed)=>setExpanded(!collapsed)} defaultCollapsed={false}>
                        H2, avatar, subTitle, toggle expand. defaultCollapsed:false
                    </PageSectionHeader>

                    <PageSectionHeader styleVariant="dark">
                        Dark, Default values (H2)
                    </PageSectionHeader>

                    <PageSectionHeader styleVariant="dark" headerVariant="H3" icon="calendar">
                        Dark, With icon, H3
                    </PageSectionHeader>

                    <PageSectionHeader styleVariant="dark" headerVariant="H2" icon="calendar" avatar={{text:"AB"}}>
                        Dark, With icon, H2, avatar
                    </PageSectionHeader>

                    <PageSectionHeader styleVariant="dark" headerVariant="H2" icon="calendar" avatar={{text:"AB"}} subTitle={{text:"Subtitle"}}>
                        Dark, With icon, H2, avatar, subTitle
                    </PageSectionHeader>

                    <PageSectionHeader styleVariant="dark" headerVariant="H2" icon="calendar" avatar={{text:"AB"}} subTitle={{text:"Subtitle", icon:"clock"}}>
                        Dark, With icon, H2, avatar, subTitle+icon
                    </PageSectionHeader>

                    <PageSectionHeader styleVariant="dark" headerVariant="H2" icon="calendar" avatar={{text:"AB"}} subTitle={{text:"Subtitle", icon:"clock", iconColor:"#f00"}} onCollapseChanged={(collapsed)=>setExpanded(!collapsed)} defaultCollapsed={true}>
                        Dark, With icon, H2, avatar, subTitle+icon+color, toggle expand, defaultCollapsed:true
                    </PageSectionHeader>

                    <PageSectionHeader styleVariant="dark" headerVariant="H2" icon="calendar" avatar={{text:"AB"}} subTitle={{text:"Subtitle", icon:"clock", iconColor:"#f00"}} onCollapseChanged={(collapsed)=>setExpanded(!collapsed)} defaultCollapsed={true} button={button}>
                        Dark, With icon, H2, avatar, subTitle+icon+color, toggle expand, defaultCollapsed:true, button
                    </PageSectionHeader>

                    <PageSectionHeader styleVariant="dark" headerVariant="H2" avatar={{text:"AB"}} subTitle={{text:"Subtitle"}} onCollapseChanged={(collapsed)=>setExpanded(!collapsed)} defaultCollapsed={false}>
                        Dark, H2, avatar, subTitle, toggle expand. defaultCollapsed:false
                    </PageSectionHeader>
                    
            </Flex>
        </div>
    );
}